import { render } from "./PopUpValidateClass.vue?vue&type=template&id=0700067d"
import script from "./PopUpValidateClass.vue?vue&type=script&lang=js"
export * from "./PopUpValidateClass.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__